<template>
  <div class="sonar-tabs">
    <div
      v-for="learningArea in learningAreas"
      :key="learningArea.id"
      :class="[
        'btn btn--primary btn--default-icon-color btn-nav',
        isActive(learningArea.slug) && 'btn-nav--active',
      ]"
      @click="goToLearningArea(learningArea.slug)"
    >
      <Passes
        class="sonar-tabs__icons"
        :passName="learningArea.name"
        :laNoBorders="true"
        :size="45"
      />
      {{ learningArea.name }}
    </div>
  </div>
</template>

<script>
import CONSTANTS from '@/constants'
import Passes from '@/components/properties/Passes.vue'

export default {
  name: 'SonarTabs',
  components: {
    Passes,
  },
  computed: {
    learningAreas() {
      return CONSTANTS.SONAR.LEARNING_AREAS
    },
  },
  methods: {
    isActive(laSlug) {
      return this.$route.params.learningArea === laSlug
    },
    goToLearningArea(laSlug) {
      this.$router.push({ name: 'sonar', params: { learningArea: laSlug } })
    },
  },
}
</script>

<style lang="scss" scoped>
.sonar-tabs {
  display: flex;
  gap: 10px;
  &__icons {
    display: none;
    @include tablet {
      display: block;
    }
  }
}
</style>
